import { render, staticRenderFns } from "./dialog.component.vue?vue&type=template&id=0cfe5e58&scoped=true&"
import script from "./dialog.component.vue?vue&type=script&lang=js&"
export * from "./dialog.component.vue?vue&type=script&lang=js&"
import style1 from "./dialog.component.vue?vue&type=style&index=1&id=0cfe5e58&scoped=true&lang=scss&"
import style2 from "./dialog.component.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe5e58",
  null
  
)

export default component.exports